import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";

const LoadingScreen = ({ position = "center" }) => {
  return (
    <div className={`d-flex justify-content-${position}`}>
      <Spinner
        animation="border"
        role="status"
      />
    </div>
  );
};

LoadingScreen.propTypes = {
  position: PropTypes.string,
};

export default LoadingScreen;
